module.exports = __webpack_public_path__ + "static/img/evidence1.aa080ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/fifth/hk/evidence1.png
// module id = MBfc
// module chunks = 1 3